import React, { useEffect } from 'react';
import { useSetRecoilState, useRecoilState } from 'recoil';
import PropTypes from 'prop-types';

import { withCartBadgeCount } from '@mo-recoil/order/selector';
import { userInfoState } from '@mo-recoil/common/user/atom';
import authApi from '@mo-apis/common/authApi';
import orderApi from '@mo-apis/order/orderApi';
import isEmpty from 'lodash-es/isEmpty';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';

const UserInfoProvider = ({ children }) => {
  const [memberInfo, setMemberInfo] = useRecoilState(userInfoState);
  const { isMultimall } = useSiteInfo();

  useEffect(() => {
    (async () => {
      const { result } = await authApi.info();
      setMemberInfo(result);
      if(memberInfo?.login && !isMultimall && isEmpty(result.employNumber)) {
        authApi.updateMemberInfo();
      }
    })();
  }, [setMemberInfo,  memberInfo?.login]);

  const setCartBadgeCount = useSetRecoilState(withCartBadgeCount);
  useEffect(() => {
    if(memberInfo?.login) {
      orderApi.getCartCount().then(({ result }) => {
        setCartBadgeCount(result);
      });
    }
  }, [setCartBadgeCount, memberInfo?.login]);

  return <>{children}</>;
};

UserInfoProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UserInfoProvider;
